import * as React from "react"
import { notBlank } from '~/utils/helpers'

import CarouselCategories from '~/components/carousel/carousel_categories'

import * as styles from "~/styles/home/block_catscarou.module.scss"

const CatsCarou = ({ block, index }) => {

  return (
    <div 
      className={styles.nd_catcarou} 
      mok-block={index}
      g={block.gender}
      mid={block.id}
    > 
      {notBlank(block.tiles) && (
        <div className={styles.catcarous_wr}>      
          <CarouselCategories tiles={block.tiles} title={block.title} block={block} />
        </div>
      )}
    </div>
  )
}



export default CatsCarou



